import { TInputEmailInstance } from 'widgets/forms/InputEmail';

/**
 * @param Widget Base widget for extending
 * @returns CustomerRegistration Class
 */
function CustomerRegistrationClassCreator(Widget: import('widgets/Widget').TWidget) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class CustomerRegistration
     * @augments Widget
     * @classdesc CustomerRegistration widget, which handles customer registration on checkout in case guest flow is restricted
     * @property {string} data-email-widget-id - Email widget id
     *
     * @example <caption>Example of CustomerRegistration usage</caption>
        <div
            data-widget="customerRegistration"
            data-step="customer"
            data-widget-event-edit="editStep"
            data-email-widget-id="${pdict.forms.customerLoginForm.email.htmlName}"
        >
            ... content
        </div>
     */
    class CustomerRegistration extends Widget {
        prefs() {
            return {
                emailWidgetId: '',
                ...super.prefs()
            };
        }

        /**
         * @description Prefills input field with an email
         * @param email Email to prefill input
         */
        prefillEmailField(email = '') {
            this.getById<TInputEmailInstance>(this.prefs().emailWidgetId, emailInput => emailInput.setValue(email));
        }

        /**
         * @description Emits widget edit event
         * @emits "edit"
         * @listens dom#click
         */
        edit() {
            this.emit('edit');
        }
    }

    return CustomerRegistration;
}

export type TCustomerRegistration = ReturnType<typeof CustomerRegistrationClassCreator>;

export type TCustomerRegistrationInstance = InstanceType<TCustomerRegistration>;

export default CustomerRegistrationClassCreator;
